// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.join-block[data-v-1c98b7d6] {\n    background: #FAFAFA;\n    border-radius: 6px;\n    padding: 10px 12px;\n}\n.join-header[data-v-1c98b7d6] {\n    font-size: 13px;\n}\n.join-table tr.is-main td[data-v-1c98b7d6] {\n    background: rgba(245, 124, 0, 0.06);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
